/*jshint scripturl:true*/
define('lib/view_helpers/markdown',['require','marked','lib/view_helpers/base','lib/Podio.Emojis','lib/Podio.Utils','underscore','lib/Podio.Routes','lib/Podio.Config'],function(require) {

  var marked = require('marked');
  var viewHelpers = require('lib/view_helpers/base');
  var Emojis = require('lib/Podio.Emojis');
  var utils = require('lib/Podio.Utils');
  var _ = require('underscore');

  var routes = require('lib/Podio.Routes');
  var config = require('lib/Podio.Config');

  function formatMentions(value){
    value = value.replace(/@\[(.+?)\]\((\w+):(\d+)\)/g, function(value, display_name, ref_type, ref_id){
      var url = void 0,
          result = '';

      if (_.contains(['contact', 'user'], ref_type)) {
        url = routes.user_path(ref_id, {format: 'html'});
      } else if ('space' === ref_type) {
        url = _.contains(config.userSpaceIds, parseInt(ref_id, 10)) ? routes.redirect_to_space_from_id_path(ref_id, {format:'html'}) : void 0;
      }

      if (!_.isUndefined(url)) {
        result = '[@{0}]({1}//{2}{3})'.format(display_name, window.location.protocol, window.location.hostname, url);
      } else {
        result = '@{0}'.format(display_name);
      }

      return result;
    });

    return value;
  }

  function formatEmojis(value) {
    return value.replace(/(?!<a[^>]*?>):([a-z0-9_+\- ]+?):(?![^<]*?<\/a>)/g, function(match, short_name) {
      if (Emojis.isValid(short_name)) {
        var css = Emojis.getStyleClass(short_name);
        return "<span title='{0}' class='{1}'></span>".format(match, css);
      } else {
        return match;
      }
    });
  }

  function format(value) {
    value = formatMentions(value);

    value = marked(value);
    value = formatEmojis(value);

    return value;
  }

  function setCustomMarkdownRules() {
    // Custom renderer
    var renderer = new marked.Renderer();

    renderer.link = function(href, title, text) {
      if(this.options.sanitize) {
        if(href[0] !== '#') {
          var schemeRegex = /^([a-zA-Z+-\.]+):/g;//capture the scheme
          var match = schemeRegex.exec(href);
          if (!match || match[1].toLowerCase() === "javascript" || match[1].length <= 2) {
            //We don't allow no scheme, javascript scheme or very short schemes (such as c:)
            return "[" + text + "](" + href + ")";
          }
        }
      }

      var out = '<a href="' + href + '"';
      if(title) {
        out += ' title="' + title + '"';
      }

      var a = document.createElement('a');
      a.href = href;

      if (_.contains(['https:', 'http:'], a.protocol)) {
        if (a.hostname === config.base_domain) {
          var itemRegex = /\/items\/(\d+)/g;
          if (href.match(itemRegex)) {
            out += ' data-link-type="no-reload" data-render-as="overlay"';
          }
        } else {
          out += ' target="_blank" rel="noreferrer"';
        }
      }

      out += '>' + text + '</a>';
      return out;
    };

    marked.setOptions({
      renderer: renderer,
      breaks: true,
      sanitize: true
    });

    // Custom lexer
    var lexer = new marked.Lexer();

    _.extend(lexer.rules, {
      heading: /^(#{1,6})\s+(.*?)\s*#*\s*(?:\n|$)/
    });

    marked.lexer = lexer;

    // Monkey-patch to not mangle mailto links
    marked.InlineLexer.prototype.mangle = function(text) {
      return text;
    };
  }

  setCustomMarkdownRules();

  var exports = {
    formatMentions: formatMentions,
    formatEmojis: formatEmojis,
    formatMarkdown: format
  };

  viewHelpers.registerHelpers(exports);

  return exports;
});

